import { ChatLeftNav } from "components/ChatLeftNav/ChatLeftNav";
import { CartNavItem } from "components/Sidebar/CartNavItem";
import { DocumentsNavItem } from "components/Sidebar/DocumentsNavItem";
import { GetHelpNavItem } from "components/Sidebar/GetHelpNavItem";
import { InkleAiNavItem } from "components/Sidebar/InkleAiNavItem";
import { KnowledgeBaseNavItem } from "components/Sidebar/KnowledgeBaseNavItem";
import { LeftBarItem } from "components/Sidebar/LeftBar";
import { SearchNavItem } from "components/Sidebar/SearchNavItem";
import { Ticket } from "components/icons/LeftNav/Ticket";
import {
  ACTION_ITEMS_CLICKED_FROM_SIDEBAR,
  CHAT_CLICKED_FROM_SIDEBAR,
} from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useIsGroupV2Platform } from "hooks/useIsGroupV2Platform";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { parse, stringify } from "qs";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

type SidebarStickyGroupProps = {
  showChat?: boolean;
  showDocuments?: boolean;
  chat?: ReactNode;
  documents?: ReactNode;
  tickets?: ReactNode;
};

export const SidebarStickyGroup = ({
  showChat = true,
  showDocuments = true,
  chat,
  documents,
  tickets,
}: SidebarStickyGroupProps) => {
  const { isCustomer, isAdmin, isCpa, isForeignCA, isUserTypeForeignCA } =
    useRoleBasedView();
  const isV2Platform = useIsGroupV2Platform();
  const { entities } = useCurrentGroupContext();
  const { trackEvent } = useAnalytics();
  const location = useLocation();

  const isFCA = isForeignCA || isUserTypeForeignCA;
  const entityId = entities[0]?.uuid;

  const isServiceUser = isCpa || isFCA;

  const parsedSearch = parse(location.search, { ignoreQueryPrefix: true });

  const search = stringify(
    { entity: parsedSearch.entity, company: parsedSearch.company },
    { skipNulls: true, addQueryPrefix: true }
  );

  const chatTo = isServiceUser ? `/chat/unreplied${search}` : `/chat${search}`;

  const handleTicketsClick = () => {
    trackEvent(ACTION_ITEMS_CLICKED_FROM_SIDEBAR);
  };

  const handleChatClick = () => {
    trackEvent(CHAT_CLICKED_FROM_SIDEBAR);
  };

  const defaultTickets = isServiceUser && (
    <button className="all:unset t-w-full" onClick={handleTicketsClick}>
      <LeftBarItem to={`/tickets${search}`} icon={Ticket}>
        Tickets
      </LeftBarItem>
    </button>
  );

  const defaultChat = showChat && (
    <button className="all:unset t-w-full" onClick={handleChatClick}>
      <ChatLeftNav to={chatTo} />
    </button>
  );

  return (
    <>
      {tickets ?? defaultTickets}
      <SearchNavItem />
      {chat ?? defaultChat}
      {isAdmin && <KnowledgeBaseNavItem />}
      {isCustomer && <CartNavItem />}
      {documents ?? (showDocuments && <DocumentsNavItem />)}
      {(isCustomer || isFCA) && <GetHelpNavItem entityId={entityId} />}
      {isCustomer && !isV2Platform && <InkleAiNavItem />}
    </>
  );
};
